import { takeLatest, all, call, put } from "redux-saga/effects";
import { API, graphqlOperation } from "aws-amplify";

import {
  fetchPlatformsStart,
  fetchPlatformsSuccess,
  fetchPlatformsError,
  createPlatformError,
  deletePlatformSuccess,
  deletePlatformError,
  updatePlatformError,
} from "./platforms.actions";
import {
  FETCH_PLATFORMS_START,
  CREATE_PLATFORM_START,
  DELETE_PLATFORM_START,
  UPDATE_PLATFORM_START,
} from "./platforms.types";
import { listPlatforms } from "../../graphql/queries";
import {
  createPlatform as createPlatformMuatation,
  deletePlatform as deletePlatformMutation,
  updatePlatform as updatePlatformMutation,
} from "../../graphql/mutations";
import putImageToS3Bucket from "../../utils/putImageToS3Bucket";
import showErrorMessage from "../../utils/showErrorMessage";

export function* fetchPlatforms() {
  try {
    const res = yield API.graphql({
      ...graphqlOperation(listPlatforms),
      authMode: 'API_KEY',
    });

    yield put(fetchPlatformsSuccess(res.data.listPlatforms.items));
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(fetchPlatformsError(errors));
  }
}

export function* createPlatform({ payload }) {
  try {
    const { values, image } = payload;
    const S3Image = yield putImageToS3Bucket(image);

    const input = {
      image: S3Image || null,
      ...values,
    };

    yield API.graphql(graphqlOperation(createPlatformMuatation, { input }));
    yield put(fetchPlatformsStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(createPlatformError(errors));
  }
}

export function* deletePlatform({ payload }) {
  try {
    const input = {
      id: payload.id,
      _version: payload._version,
    };

    const res = yield API.graphql(
      graphqlOperation(deletePlatformMutation, { input })
    );

    yield put(deletePlatformSuccess(res.data.deletePlatform));
    yield put(fetchPlatformsStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(deletePlatformError(errors));
  }
}

export function* updatePlatform({ payload }) {
  try {
    const { platform, image, values } = payload;
    const S3Image = yield putImageToS3Bucket(image);

    const input = {
      id: platform.id,
      image: S3Image || platform.image,
      _version: platform._version,
      ...values,
    };

    yield API.graphql(graphqlOperation(updatePlatformMutation, { input }));

    yield put(fetchPlatformsStart());
  } catch ({ errors }) {
    showErrorMessage(errors);
    yield put(updatePlatformError(errors));
  }
}

// Platforms sagas
export function* onFetchPlatformsStart() {
  yield takeLatest(FETCH_PLATFORMS_START, fetchPlatforms);
}

// Single platform sagas
export function* onCreatePlatformStart() {
  yield takeLatest(CREATE_PLATFORM_START, createPlatform);
}

export function* onDeletePlatformStart() {
  yield takeLatest(DELETE_PLATFORM_START, deletePlatform);
}

export function* onUpdatePlatformStart() {
  yield takeLatest(UPDATE_PLATFORM_START, updatePlatform);
}

export function* platformsSagas() {
  yield all([
    call(onFetchPlatformsStart),
    call(onDeletePlatformStart),
    call(onUpdatePlatformStart),
    call(onCreatePlatformStart),
  ]);
}
